// The club's booking rules, typed in Partners (Settings → Widgets → Policies →
// Booking rules) and delivered already resolved on `saas.widgetRules`: a category
// the club never saved arrives with the house default, a saved empty list arrives
// empty. One list per booking category, and the only rules the widget states.
const RULES_KEY_BY_CATEGORY_TYPE = {
  "category-service-private": "private",
  "category-service-class": "class",
  "category-service-court": "court"
};

const RULES_KEY_BY_CART_TYPE = { lesson: "private", class: "class", court: "court" };

const NO_RULES = [];

export function clubRulesForCategoryType(widgetRules, categoryType) {
  const key = RULES_KEY_BY_CATEGORY_TYPE[categoryType];
  return (key && widgetRules?.[key]) || NO_RULES;
}

// Private and class rules are written for packs (dates picked upfront, validity
// windows), so they belong in the pack's "Before you buy" box and confirm dialog,
// not on a single booking's checkout. Courts have no upfront packs and events
// have no list of their own anywhere else, so checkout is where theirs show.
const CHECKOUT_RULE_KEYS = ["court", "event"];

// Events are class services in a class category of their own, so the service —
// not the cart line's "class" type — tells an event apart from a regular class.
const rulesKeyForCartItem = (item, services) => {
  const service = (services || []).find((s) => s._id === item.serviceId);
  if (service?.isStandaloneClassCategory) return "event";
  if (service?.categoryType) return RULES_KEY_BY_CATEGORY_TYPE[service.categoryType];
  return RULES_KEY_BY_CART_TYPE[item.type];
};

export function checkoutRulesForCartItem(widgetRules, item, services) {
  if (!item) return NO_RULES;
  const key = rulesKeyForCartItem(item, services);
  return (CHECKOUT_RULE_KEYS.includes(key) && widgetRules?.[key]) || NO_RULES;
}
